import React, { createContext, useContext, useState } from 'react';
import Cookies from 'js-cookie';

const CookieConsentContext = createContext();

export const CookieConsentProvider = ({ children }) => {
  const initialConsent = Cookies.get('cookieConsent');
  const [consent, setConsent] = useState(initialConsent === 'true');

  const updateConsent = (value) => {
    Cookies.set('cookieConsent', value, { expires: 365 });
    setConsent(value);
  };

  return (
    <CookieConsentContext.Provider value={{ consent, updateConsent }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => useContext(CookieConsentContext);
